import React from 'react'
import { selectNavHeight } from "../../../../redux/navbar/navHeightSlice";
import { useSelector } from "react-redux";
import DOBViolation from './DOBViolationTracking'

const DOBViolationTracking = () => {
    const navHeight = useSelector(selectNavHeight);
  
  return (
  <div  className="mx-auto w-full"
    style={{
      marginTop: navHeight,
      height: `calc(100vh - ${navHeight}px)`,
      overflow: "auto",
    }} >
      <DOBViolation />
    </div>
  );
}

export default DOBViolationTracking